import { Api } from 'utils';

class ClientProfileService {
	
	static client = {
		save: async (params?: any) => Api.createResponse('client/profile/save',params),
		deleteAccount: async (params?: any) => Api.createResponse('client/profile/delete-account',params),
		updateAddresses: async (params?: any) => Api.createResponse('client/profile/update-addresses',params)
	}

}

export default ClientProfileService;